var exports = {
  "zr": "MessageComponentsV2.module__root___YkEtdD",
  "kL": "MessageComponentsV2.module__container___YkEtdD",
  "sW": "MessageComponentsV2.module__accented___YkEtdD",
  "uW": "MessageComponentsV2.module__section___YkEtdD",
  "rO": "MessageComponentsV2.module__sectionText___YkEtdD",
  "fJ": "MessageComponentsV2.module__accessoryButton___YkEtdD",
  "xn": "MessageComponentsV2.module__thumbnail___YkEtdD",
  "aU": "MessageComponentsV2.module__textDisplay___YkEtdD",
  "me": "MessageComponentsV2.module__separator___YkEtdD",
  "f5": "MessageComponentsV2.module__spacingLarge___YkEtdD",
  "yF": "MessageComponentsV2.module__divider___YkEtdD",
  "nV": "MessageComponentsV2.module__gallery___YkEtdD",
};

module.exports = exports;
